import { render, staticRenderFns } from "./PersonaIntro.vue?vue&type=template&id=55a86755&scoped=true"
import script from "./PersonaIntro.vue?vue&type=script&lang=js"
export * from "./PersonaIntro.vue?vue&type=script&lang=js"
import style0 from "./PersonaIntro.vue?vue&type=style&index=0&id=55a86755&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a86755",
  null
  
)

export default component.exports